import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { notification } from 'antd'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import * as routes from 'core/routing/constants/index'

import { injectIntl, FormattedMessage } from 'react-intl'
import _ from 'lodash'
import useGetPointsOfSales from 'core/hooks/useGetPointsOfSales'
import useGetConfig from 'core/hooks/useGetConfig'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import LandingPageGuide from 'core/templates/LandingPageGuide'
import { Row, Col, Form, Button, Drawer, Skeleton, Tooltip, Input } from 'core/components/ui'
import wizardsShape from 'core/components/wizard/shapes'
import svg from 'assets/svg'
import PageLoading from 'core/components/page-loading'
import TitleIcon from 'core/layouts/title-icon'
import { getDistanceFromCoordinates } from 'core/utils/geolocation'
import { tradeInShape } from '../shapes'

import configurationShape from '../../configuration/shapes'

import MapComponent from '../../core/components/maps/GoogleMapComponent'
import DistributorList from './DistributorList'

import {
  MapWrapperContainer,
  StyledPageLoading,
  StyledInputGroup,
  StyledZipCodeInput,
  InputIcon,
  PointOfSalesTitle,
  PointOfSalesDatas,
  PointOfSalesDatasWrapper,
  DistributorNumber,
  TitleSpan
} from './styled'

const Distributor = props => {
  const {
    history,
    intl,
    setWizards,
    wizards,
    setTradeIn,
    tradeIn,
    configuration,
    setConfiguration,
    form
  } = props

  const [zipCode, setZipCode] = useState(null)
  const [selectedPointOfSale, setSelectedPointOfSaleId] = useState(null)
  const [canFetchPos, setCanFetchPos] = useState(false)
  const [modalVisibleDistributors, setModalVisibleDistributors] = useState(false)
  const [geolocationEnabled, setGeolocationEnabled] = useState()
  const [posLatitude, setPosLatitude] = useState()
  const [posLongitude, setPosLongitude] = useState()

  useEffect(() => {
    if (tradeIn.pointOfSales && tradeIn.makeId && tradeIn.dealerCode) {
      const aStepsActive = wizards[wizards.activeWizard]
      const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_DISTRIBUTOR) + 1

      history.push(aStepsActive[nextIndex].hash)
    }
  }, [])

  // const [inputValue, setInputValue] = useState('')

  const { getFieldDecorator } = form

  const {
    getPointsOfSales,
    loadingPointsOfSales,
    pointsOfSales,
    getPointOfSales,
    loadingPointOfSales,
    pointOfSales,
    getUserGeolocation,
    getZipcodeByCoordinates,
    userZipcode,
    userCoordinates
  } = useGetPointsOfSales({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { getConfig, config, currentPrivacyPolicy, loading } = useGetConfig({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const { filtersList, user } = tradeIn
  const { pointsOfSalesList } = filtersList

  // const pointsOfSalesList = filtersList.pointsOfSalesList.filter(item => item.distance <= 100)

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      () => {
        setGeolocationEnabled(true)
      },
      err => {
        /* eslint-disable-next-line */
        console.log(err.message)
        setGeolocationEnabled(false)
      }
    )
    setCanFetchPos(false)
  }, [])

  const desactivateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_DISTRIBUTOR) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_DISTRIBUTOR) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const handleChangeZipCode = (rule, value, callback) => {
    const ok = () => {
      const extendedFiltersList = {
        ...filtersList
        // pointsOfSalesList: null
      }
      setTradeIn({
        ...tradeIn,
        filtersList: extendedFiltersList
        // pointOfSales: null
      })
      // setZipCode(value)

      callback()
    }

    /*const ko = () => {
      setZipCode(null)
      callback(<FormattedMessage id="ui-input-zipcode-invalid" />)
    }*/
    if (value.toString().length > 10)
      return callback(<FormattedMessage id="ui-input-xMaxLength" values={{ numberMax: 10 }} />)

    // const regexp = /^(([0-8][0-9])|(9[0-5]))[0-9]{3}$/
    // return regexp.test(value) ? ok() : ko()
    return ok()
  }

  const updateTradein = selectedPointOfSales => {
    const { campaign } = configuration
    const { lang } = campaign
    setTradeIn({
      ...tradeIn,
      pointOfSales: {
        ...selectedPointOfSales,
        distance: userCoordinates
          ? getDistanceFromCoordinates(userCoordinates, selectedPointOfSales, lang.split('-')[1])
          : null
      }
    })
  }

  const handleChangePointOfSales = selectedPointOfSales => {
    //const { entityId } = _.first(pointsOfSales.filter(item => item.id === id && item.entityId ===))
    // setSelectedPointOfSaleId(selectedPointOfSales.id)
    // setModalVisibleDistributors(false)

    setSelectedPointOfSaleId(selectedPointOfSales.id)
    setModalVisibleDistributors(false)
    setPosLatitude(selectedPointOfSales.latitude)
    setPosLongitude(selectedPointOfSales.longitude)
    updateTradein(selectedPointOfSales)
  }

  const getPointOfSaleFromDistance = () => {
    let step = 100

    let pointOfSaleFromDistanceList = []

    if (pointsOfSalesList && pointsOfSalesList.length > 0) {
      if (pointsOfSalesList.length < 4) {
        pointOfSaleFromDistanceList = pointsOfSalesList
      } else {
        while (pointOfSaleFromDistanceList.length < 4) {
          /*eslint-disable-next-line*/
          pointOfSaleFromDistanceList = pointsOfSalesList.filter(item => item.distance <= step)

          step += 100
        }
      }

      return pointOfSaleFromDistanceList
    }
    return []
  }

  const [newMarkers, setNewMarkers] = useState([])

  const onClickMarker = id => {
    const params = {
      id
    }
    if (isMobile) {
      getPointOfSales(params)

      setModalVisibleDistributors(true)
      setSelectedPointOfSaleId(id)
      updateTradein(pointOfSales)
    }
  }

  const renderPointOfSales = () => {
    if (!tradeIn.pointOfSales) return false

    return (
      <>
        <StyledPageLoading
          style={loadingPointOfSales || loadingPointsOfSales ? {} : { display: 'none' }}
        >
          <PageLoading />
        </StyledPageLoading>
        {posLatitude && posLongitude && (
          <MapWrapperContainer>
            <MapComponent
              markers={newMarkers}
              center={{ lat: posLatitude, lng: posLongitude }}
              onClickMarker={onClickMarker}
            />
          </MapWrapperContainer>
        )}
      </>
    )
  }

  useEffect(() => {
    if (
      tradeIn.pointOfSales &&
      moment(tradeIn.vehicle.catalog).year() >=
        new Date().getFullYear() - configuration.automaticValidationSetting.maximumAgeTradeInCars
    ) {
      activateNextStep()
    } else if (
      tradeIn.pointOfSales &&
      moment(tradeIn.vehicle.catalog).year() <
        new Date().getFullYear() - configuration.automaticValidationSetting.maximumAgeTradeInCars
    ) {
      notification.error({
        message: intl.formatMessage({ id: 'error' }),
        description: intl.formatMessage({ id: 'tradeIn-distributor-notification-tooOld' })
      })
      desactivateNextStep()
    } else if (!configuration.tradeInContext.loading) {
      desactivateNextStep()
    }
  }, [configuration.automaticValidationSetting])

  useEffect(() => {
    //const distinctDistances = pointsOfSalesList && _.uniq(_.map(pointsOfSalesList, x => x.distance))
    if (
      zipCode &&
      pointsOfSalesList &&
      !configuration.tradeInContext
        .loading /*&&
      (distinctDistances.length > 1 || distinctDistances[0] !== null)*/
    ) {
      setSelectedPointOfSaleId(_.orderBy(pointsOfSalesList, 'distance', 'asc')[0].id)
      setCanFetchPos(true)
    }
  }, [pointsOfSalesList])

  useEffect(() => {
    const runIt = (list, userGeolocation) => {
      const { campaign } = configuration
      const { deactivatedPointOfSalesIds, lang } = campaign
      const extendedFiltersList = {
        ...filtersList,
        pointsOfSalesList: list
          .filter(x => !deactivatedPointOfSalesIds.includes(x.id))
          .map(x => ({
            ...x,
            distance: userGeolocation
              ? getDistanceFromCoordinates(userGeolocation, x, lang.split('-')[1])
              : null
          }))
      }

      setTradeIn({
        ...tradeIn,
        filtersList: extendedFiltersList
        // pointOfSales: null
      })
    }

    if (pointsOfSales && pointsOfSales.length > 0) runIt(pointsOfSales, userCoordinates)
  }, [pointsOfSales, userCoordinates])

  useEffect(() => {
    const runIt = async oldConfig => {
      setConfiguration({
        ...configuration,
        currentPricingPolicy: oldConfig.currentPricingPolicy,
        opportunitySettings: oldConfig.opportunitySettings,
        automaticValidationSetting: oldConfig.automaticValidationSetting
      })
    }
    if (config) runIt(config)
  }, [config])

  useEffect(() => {
    const runIt = id => {
      const params = {
        id
      }

      getPointOfSales(params)
      setCanFetchPos(false)
    }
    if (!loading && canFetchPos) runIt(selectedPointOfSale)
  }, [loading, canFetchPos])

  useEffect(() => {
    const runIt = (pos, userGeolocation) => {
      const { campaign } = configuration
      const { lang } = campaign
      setTradeIn({
        ...tradeIn,
        pointOfSales: {
          ...pos,
          distance: userGeolocation
            ? getDistanceFromCoordinates(userGeolocation, pos, lang.split('-')[1])
            : null
        }
      })
      activateNextStep()

      //Moved marker creation here to avoid rerender the map for nothing
      const { latitude, longitude } = pos
      setPosLatitude(latitude)
      setPosLongitude(longitude)
    }
    if (pointOfSales) runIt(pointOfSales, userCoordinates)
  }, [pointOfSales])

  useEffect(() => {
    const renderNewMarkers = () => {
      const x = _.orderBy(getPointOfSaleFromDistance(), 'distance', 'asc').map(pointOfSale => {
        const {
          id,
          email,
          name,
          latitude,
          longitude,
          address1,
          address2,
          complementaryAddress1,
          complementaryAddress2,
          city,
          phone,
          phonePrefixCode
        } = pointOfSale
        const mailto = pointOfSale && email ? `mailto:${email}` : null

        const contentPopUp = (
          <>
            <PointOfSalesDatasWrapper>
              {name && <PointOfSalesTitle>{name}</PointOfSalesTitle>}
              {(address1 || address2) && (
                <PointOfSalesDatas>
                  {address1} {address2}
                </PointOfSalesDatas>
              )}
              {(complementaryAddress1 || complementaryAddress2) && (
                <PointOfSalesDatas>
                  {complementaryAddress1} {complementaryAddress2}
                </PointOfSalesDatas>
              )}
              {pointOfSale.zipCode && city && (
                <PointOfSalesDatas>
                  {pointOfSale.zipCode} {city}
                </PointOfSalesDatas>
              )}
            </PointOfSalesDatasWrapper>
            {(email || phone) && (
              <PointOfSalesDatasWrapper>
                <PointOfSalesTitle>
                  {intl.formatMessage({ id: 'tradeIn-distributor-pointofsales-contact-title-2' })}
                </PointOfSalesTitle>
                {email && (
                  <PointOfSalesDatas>
                    <a href={mailto}>{pointOfSale.email}</a>
                  </PointOfSalesDatas>
                )}
                <PointOfSalesDatas>
                  {phonePrefixCode} {phone}
                </PointOfSalesDatas>
              </PointOfSalesDatasWrapper>
            )}
          </>
        )

        return { id, content: contentPopUp, position: { lat: latitude, lng: longitude } }
      })
      const userMarker = userCoordinates && {
        position: { lat: userCoordinates.latitude, lng: userCoordinates.longitude },
        user: true
      }

      if (userMarker) {
        setNewMarkers([userMarker, ...x])
        // setPosLatitude(x[0].position.lat)
        // setPosLongitude(x[0].position.lng)
        setPosLatitude(userCoordinates.latitude)
        setPosLongitude(userCoordinates.longitude)
      } else {
        setNewMarkers(x)
      }
    }
    if (pointsOfSalesList) renderNewMarkers()
  }, [pointOfSales, userCoordinates])

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      position => {
        getZipcodeByCoordinates(position.coords)

        if (userZipcode) {
          getUserGeolocation({ zipCode: userZipcode })
        }
      },
      err => {
        /* eslint-disable-next-line */
        console.log(err.message)
      }
    )
  }, [])
  useEffect(() => {
    if (isMobile && !loadingPointOfSales) {
      if (document.getElementsByClassName('selected')[0]) {
        document.getElementsByClassName('selected')[0].scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [loadingPointOfSales])

  const handleClickZipCode = value => {
    const { campaign } = configuration
    const { groupCampaign } = campaign

    getPointsOfSales({
      groupCampaign,
      zipCode
    })
    if (value) {
      getUserGeolocation({ zipCode: value })
      setZipCode(value)
    }
    setModalVisibleDistributors(true)

    const runIt = async pos => {
      const { uid } = campaign
      getConfig({ token: uid, pointOfSaleId: pos })

      setTradeIn({
        ...tradeIn,
        user: { ...tradeIn.user, zipCode },
        privacyPolicy: { ...currentPrivacyPolicy }
      })
      setCanFetchPos(true)
    }
    if (selectedPointOfSale) runIt(selectedPointOfSale)
  }

  const renderTitle = () => (
    <Skeleton loading={loadingPointsOfSales} active>
      <p style={{ fontStyle: 'italic' }}>
        <DistributorNumber>{getPointOfSaleFromDistance().length}</DistributorNumber>{' '}
        <TitleSpan>
          <FormattedMessage
            id="distributors"
            values={{ value: getPointOfSaleFromDistance().length }}
          />
        </TitleSpan>{' '}
        {getPointOfSaleFromDistance().length > 1 && (
          <FormattedMessage
            id="distributors-found"
            values={{ value: getPointOfSaleFromDistance().length }}
          />
        )}
      </p>
    </Skeleton>
  )

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      position => {
        getZipcodeByCoordinates(position.coords)
        const { campaign } = configuration
        const { groupCampaign } = campaign

        if (zipCode) {
          getPointsOfSales({
            groupCampaign,
            zipCode
          })
          if (zipCode) {
            getUserGeolocation({ zipCode })
          }
          if (isMobile) setModalVisibleDistributors(true)
          // setInputValue(userZipcode)
          // document.getElementById('#Distributor_zipCode').value = zipCode

          form.setFieldsValue({ zipCode: userZipcode })

          // setFieldValue('zipCode', userZipcode)
          handleClickZipCode(userZipcode)
        }
      },
      err => {
        /* eslint-disable-next-line */
        console.log(err.message)
      }
    )
  }

  useEffect(() => {
    const { campaign } = configuration
    const { groupCampaign } = campaign

    if (zipCode) {
      getPointsOfSales({
        groupCampaign,
        zipCode
      })
      // getUserGeolocation({ zipCode: e.target.value })
    }
  }, [zipCode])
  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedFiltersList = {
      ...filtersList
    }
    setTradeIn({
      ...tradeIn,
      filtersList: extendedFiltersList,
      pointOfSales:
        tradeIn.dealerCode && tradeIn.makeId && tradeIn.pointOfSales ? tradeIn.pointOfSales : null
    })

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.TRADEIN_DISTRIBUTOR
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    const currentStepIndex = _.findIndex(
      aStepsActive,
      item => item.hash === routes.TRADEIN_DISTRIBUTOR
    )

    if (currentStepIndex === 0 && !configuration.tradeInContext.loading) {
      const extendedSteps = aStepsActive.map((item, index) => {
        if (index > currentStepIndex) {
          const extendedItem = { ...item, isActive: false }
          return extendedItem
        }
        return item
      })

      const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
      setWizards(extentedWizards)
    }

    if (user && user.zipCode) setZipCode(user.zipCode)

    if (tradeIn.pointOfSales) activateNextStep()
  }, [])

  useEffect(() => {
    if (configuration.tradeInContext.car && tradeIn.pointOfSales) {
      // setZipCode(user.zipCode)
      setSelectedPointOfSaleId(tradeIn.pointOfSales.id)
      handleClickZipCode()
    }
    // setIsLoading(false)
  }, [tradeIn.pointOfSales])

  useEffect(() => {
    setZipCode(userZipcode)
    if (userZipcode) {
      getUserGeolocation({ zipCode: userZipcode })
    }
  }, [userZipcode])

  return (
    <>
      {props.configuration.campaign.tradeInConfig === 1 && <LandingPageGuide />}

      <MainContentWrapper>
        <TitleIcon
          cssId="globaldealer-title-9"
          title={intl.formatMessage({
            id: 'tradeIn-distributor-subtitle'
          })}
          style={{ marginBottom: '30px' }}
        />
        <Row type="flex" gutter={10} style={{ marginBottom: '20px' }}>
          <Col lg={9} sm={12} xs={24}>
            <Form>
              <Row type="flex" gutter={isMobile ? 10 : 20}>
                <Col sm={24} xs={24}>
                  <StyledInputGroup compact>
                    <Button onClick={() => getCurrentLocation()}>
                      {geolocationEnabled ? (
                        <InputIcon svg={svg.crosshairs} />
                      ) : (
                        <Tooltip
                          overlayClassName="globaldealer-tooltip-information"
                          title={intl.formatMessage({
                            id: 'tradeIn-distributor-tooltip'
                          })}
                        >
                          <InputIcon
                            svg={svg.crosshairsOff}
                            style={{ margin: '0', padding: '0' }}
                          />
                        </Tooltip>
                      )}
                    </Button>

                    <StyledZipCodeInput>
                      {getFieldDecorator('zipCode', {
                        initialValue: userZipcode,
                        rules: [
                          {
                            validator: handleChangeZipCode
                          }
                        ]
                      })(
                        <Input
                          onPressEnter={e => handleClickZipCode(e.target.value)}
                          placeholder={intl.formatMessage({
                            id: 'tradeIn-distributor-input-placeholder'
                          })}
                          // onChange={e => {
                          //   setInputValue(e)
                          // }}
                        />
                      )}
                    </StyledZipCodeInput>
                    <Button onClick={() => handleClickZipCode(form.getFieldValue('zipCode'))}>
                      <InputIcon svg={svg.magnifyingGlass} />
                    </Button>
                  </StyledInputGroup>
                  {zipCode && renderTitle()}
                </Col>
              </Row>
              {zipCode && !isMobile && (
                <Skeleton loading={loadingPointsOfSales} active>
                  <DistributorList
                    pointsOfSalesList={_.orderBy(getPointOfSaleFromDistance(), 'distance', 'asc')}
                    handleChangePointOfSales={handleChangePointOfSales}
                    selectedPointOfSale={selectedPointOfSale}
                  />
                </Skeleton>
              )}
            </Form>
          </Col>
          <Col lg={15} sm={24} xs={24}>
            {renderPointOfSales()}
          </Col>
        </Row>
        {isMobile && (
          <Drawer
            placement="bottom"
            height="600"
            destroyOnClose
            title={renderTitle()}
            visible={modalVisibleDistributors}
            footer={null}
            headerStyle={{ padding: '10px' }}
            onClose={() => setModalVisibleDistributors(false)}
          >
            <Skeleton loading={loadingPointsOfSales} active>
              <DistributorList
                pointsOfSalesList={_.orderBy(getPointOfSaleFromDistance(), 'distance', 'asc')}
                handleChangePointOfSales={handleChangePointOfSales}
                selectedPointOfSale={selectedPointOfSale}
              />
            </Skeleton>
          </Drawer>
        )}
      </MainContentWrapper>
    </>
  )
}

Distributor.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  form: PropTypes.shape().isRequired,
  configuration: configurationShape.isRequired,
  setConfiguration: PropTypes.func.isRequired
}

export default withRouter(injectIntl(Form.create({ name: 'Distributor' })(Distributor)))
